import React from 'react';

export const PropertyTypePropertySubType = ({
  PropertyTypeInPropertySubType,
  getPropertySubTypeId,
  handlePropertySubType,
}) => {
  return (
    <div className="property-filter-block">
      {PropertyTypeInPropertySubType && (
        <label className="property-details-label">Property Sub Type</label>
      )}
      <div className="property-pill-grid">
        {PropertyTypeInPropertySubType &&
          React.Children.toArray(
            PropertyTypeInPropertySubType?.map(
              (propertySubtype, index) => (
                <button
                  type="button"
                  key={index}
                  className={`property-pill ${
                    // eslint-disable-next-line eqeqeq
                    getPropertySubTypeId == propertySubtype?.id
                      ? 'property-pill--active'
                      : ''
                  }`}
                  onClick={handlePropertySubType}
                  data-propertysubtype={propertySubtype?.id}
                >
                  {propertySubtype?.text}
                </button>
              ),
            ),
          )}
      </div>
    </div>
  );
};
